import React from 'react';
export const MergePolygon = () => {
  return <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path d="M8 16H3C2.44772 16 2 15.5523 2 15V3C2 2.44772 2.44772 2 3 2H15C15.5523 2 16 2.44772 16 3V8M8 16V21C8 21.5523 8.44772 22 9 22H21C21.5523 22 22 21.5523 22 21V9C22 8.44772 21.5523 8 21 8H16M8 16V14M8 16H10M16 8H14M16 8V10M16 14V15C16 15.5523 15.5523 16 15 16H14M8 10V9C8 8.44772 8.44772 8 9 8H10" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>{' '}
      </g>
    </svg>;
};